import React from 'react'
import './about.css'
import ME from '../../assets/me-about.jpg'
import {FaAward} from 'react-icons/fa'
import {AiOutlineSafetyCertificate} from 'react-icons/ai'
import {VscFolderLibrary} from 'react-icons/vsc'

const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className='container about__container'>
        <div className='about__me'>
          <div className='about__me-image'>
            <img src={ME} alt='About Image' />
          </div>
        </div>
      

      <div className='about__content'>
        <div className='about__cards'>
          <article className='about__card'>
            <FaAward className='about__icon'/>
            <h5>Enterprise Experience</h5>
            <small>8+ Years at Scale</small>
          </article>

          <article className='about__card'>
            <AiOutlineSafetyCertificate className='about__icon'/>
            <h5>Leadership & Strategy</h5>
            <small>MBA + PSM I/II Certified</small>
          </article>

          <article className='about__card'>
            <VscFolderLibrary className='about__icon'/>
            <h5>Technical Depth</h5>
            <small>Full Stack + Cloud</small>
          </article>
        </div>

        <p>
          Enterprise Technical Consultant with 8+ years driving customer success through complex implementations, production support, and digital transformation at scale. I combine technical depth (Full Stack: Java, React, APIs, Cloud) with business acumen (MBA in Strategic Management) to translate customer needs into strategic technical solutions.
          <br/><br/>
          Proven ability to lead cross-functional teams, manage enterprise production systems, and deliver measurable customer impact. Recognized with multiple awards for customer success, accountability, and collaboration. Specialized in technical account management, enterprise implementation, and modernization initiatives.
        </p>

        <a href="#contact" className='btn btn-primary'>Let's Talk</a>
      </div>
    </div>
    </section>
  )
}

export default About